// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2joQs","col":"styles_col__17QET"};